module.exports = __webpack_public_path__ + "static/media/overpass-bold.03f13d81.ttf";